import { resolveImagePath } from '@/utils/imageResolver';

interface GalleryImage {
  src: string;
  alt: string;
  href?: string;
}

const galleryImages: GalleryImage[] = [
  {
    src: "/wp-content/uploads/Dianas-Photos-NewsStory-610x610.jpg",
    alt: "Dianas-Photos-NewsStory",
    href: "https://dianasmorningbrew.com/wp-content/uploads/Dianas-Photos-NewsStory.jpg"
  },
  {
    src: "/wp-content/uploads/Dianas-FreshBread-Paralax-610x610.jpg",
    alt: "Fresh Bread Daily",
    href: "https://dianasmorningbrew.com/wp-content/uploads/Dianas-FreshBread-Paralax.jpg"
  },
  {
    src: "/wp-content/uploads/Dianas-Photos-FreshBakedPastries-2-610x610.jpg",
    alt: "Dianas-Photos-FreshBakedPastries-2",
    href: "https://dianasmorningbrew.com/wp-content/uploads/Dianas-Photos-FreshBakedPastries-2.jpg"
  },
  {
    src: "/wp-content/uploads/Dianas-Photos-FreshBakedPastries-610x610.jpg",
    alt: "Dianas-Photos-FreshBakedPastries",
    href: "https://dianasmorningbrew.com/wp-content/uploads/Dianas-Photos-FreshBakedPastries.jpg"
  }
];

export function PhotoGallery() {
  return (
    <section className="bg-cream-base py-16 relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute left-0 top-1/2 -translate-y-1/2 w-32 h-32 opacity-10">
        <div className="w-full h-full border-4 border-brown-dark rounded-full"></div>
      </div>
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-24 h-24 opacity-10">
        <div className="w-full h-full bg-brown-dark rounded-full"></div>
      </div>
      
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h3 className="text-brown-medium font-medium text-lg mb-2 font-roboto">
            Our Story
          </h3>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-brown-dark font-bebas-neue tracking-wide">
            IN PICTURES
          </h2>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {galleryImages.map((image, index) => (
            <div key={index} className="group">
              <a
                href={image.href}
                className="block relative overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 group-hover:scale-105"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="aspect-square">
                  <img
                    src={resolveImagePath(image.src)}
                    alt={image.alt}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                    loading="lazy"
                  />
                </div>
                {/* Overlay effect */}
                <div className="absolute inset-0 bg-brown-dark bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 flex items-center justify-center">
                  <div className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <svg 
                      className="w-8 h-8" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        strokeWidth="2" 
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>

        {/* Instagram handle */}
        <div className="text-center mt-12">
          <p className="text-brown-dark font-roboto text-sm tracking-wider">
            @dianasmorningbrew
          </p>
        </div>
      </div>
    </section>
  );
}